import { connect } from 'react-redux';
import React, { Component } from 'react';
import {  LinkContainer } from 'react-router-bootstrap';
import { Glyphicon, Nav, Navbar, NavItem, NavDropdown, Col, Grid, Row, Button } from 'react-bootstrap';
import LogoIcyteg from '../Images/Logo.png';
import '../css/Global.css';
import '../css/MenuPrincipal.css';
 

class MenuPrincipal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            LogoMicro: false,
            Mostrar: true
        }

        this.MenuDoc = this.MenuDoc.bind(this);
        this.MenuMaest = this.MenuMaest.bind(this);
        this.MenuEsp = this.MenuEsp.bind(this);
        this.MenuLic = this.MenuLic.bind(this);
        this.MenuDip = this.MenuDip.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.mostrarUniversum = this.mostrarUniversum.bind(this);
    }

    handleScroll(event) {
       
        if ((window.pageYOffset > 120 && this.state.LogoMicro == false) || window.pageYOffset <= 120 && this.state.LogoMicro == true) {
            this.setState({ LogoMicro: !this.state.LogoMicro });
        }
    }

    componentDidMount() {

        window.addEventListener('scroll', this.handleScroll);
        
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

   

    MenuDoc() {
        return (
            <Glyphicon glyph='education'>  <span>Doctorados</span> </Glyphicon>
        );
    }

    MenuMaest() {
        return (
            <Glyphicon glyph='blackboard'>  <span>Maestrías</span> </Glyphicon>
        );
    }

    MenuEsp() {
        return (
            <Glyphicon glyph='equalizer'>  <span>Especialidades</span> </Glyphicon>
        );
    }

    MenuLic() {
        return (
            <Glyphicon glyph='knight'> <span>Licenciaturas</span> </Glyphicon>
        );
    }

    MenuDip() {
        return (
            <Glyphicon glyph='object-align-horizontal'> <span>Diplomados</span> </Glyphicon>
        );

    }
    mostrarUniversum() {
            this.props.mostrarMenu(false);
    }
    render() {
        return (
            <div className="DivPrincipal">
                <div className="DivMenu1">
                    <Grid>
                        <Row>
                            
                            <Col style={{ textAlign: "right" }}>
                                <a  href="/Universum" className="Universum">
                                    <Glyphicon  glyph='play-circle' style={{ padding: "10px", top: "12px", cursor: "pointer", right: "120px", fontSize: "14pt" }}> <span className="Universum">Entrar a mis cursos</span> </Glyphicon>
                                </a>
                            </Col>
                        </Row>
                    </Grid>

                </div>
                <Grid>
                   
                    <Row className="DivMenu2">
                        <Col xs={2} style={{ backgroundColor: "transparent" }}>
                            {!this.state.LogoMicro ?
                                <img src={LogoIcyteg} alt='Logo ICYTEG' className="MiniLogo" />
                                : <span></span>
                                }
                        </Col>
                        <Col xs={10}>
                            <Navbar fluid collapseOnSelect  style={{bottom: "0px", top:"auto"}}>
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                {this.state.LogoMicro ?
                                    <Navbar.Brand>
                                        <img src={LogoIcyteg} alt='Logo ICYTEG' className="MicroLogo" />
                                    </Navbar.Brand>
                                    : <span></span>
                                }
                                <Navbar.Collapse>
                                    <Nav>
                                        <LinkContainer to={'/'} exact>
                                            <NavItem >
                                                <Glyphicon glyph='home' /> Inicio
                                            </NavItem>
                                        </LinkContainer>

                                        <NavDropdown title={this.MenuDoc()} >

                                            <LinkContainer to={'/Doctorado/Educacion_Especial'} >
                                                <NavItem>Doctorado en Educaci&oacute;n Especial</NavItem>
                                            </LinkContainer>

                                            <LinkContainer to={'/Doctorado/Educacion_y_Ambientes_de_Aprendizaje_Digital'} >
                                                <NavItem >Doctorado en Educaci&oacute;n y Ambientes de Aprendizaje Digital</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Doctorado/Pedagogia'} >
                                                <NavItem >Doctorado en Pedagog&iacute;a</NavItem>
                                            </LinkContainer>
                                        </NavDropdown>
                                        <NavDropdown title={this.MenuMaest()} >

                                            <LinkContainer to={'/Maestria/Educacion_Especial'} >
                                                <NavItem>Maestr&iacute;a en Educaci&oacute;n Especial</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Maestria/Educacion_Nutricional'} >
                                                <NavItem>Maestr&iacute;a en Ciencias de la Educaci&oacute;n Nutricional</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Maestria/Educacion_y_Nuevas_Tecnologias'} >
                                                <NavItem>Maestr&iacute;a en Educaci&oacute;n y Nuevas Tecnolog&iacute;as</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Maestria/Sociologia_Educativa'} >
                                                <NavItem>Maestr&iacute;a en Sociolog&iacute;a Educativa</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Maestria/Administracion_Publica'} >
                                                <NavItem>Maestr&iacute;a en Administraci&oacute;n P&uacute;blica</NavItem>
                                            </LinkContainer>
                                        </NavDropdown>
                                        <NavDropdown title={this.MenuEsp()} >

                                            <LinkContainer to={'/Especialidad/Educacion_y_Nuevas_Tecnologias'} >
                                                <NavItem>Especialidad en Educaci&oacute;n y Nuevas Tecnolog&iacute;as</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Especialidad/Calidad_Educativa'} >
                                                <NavItem>Especialidad en Calidad Educativa</NavItem>
                                            </LinkContainer>
                                        </NavDropdown>
                                        <NavDropdown title={this.MenuLic()} >

                                            <LinkContainer to={'/Ingenieria/Robotica'} >
                                                <NavItem >Ing. en Rob&oacute;tica</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Ingenieria/Control_y_Automatizacion'} >
                                                <NavItem>Ing. en Control y Automatizaci&oacute;n</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Licenciatura/Psicologia_Social'} >
                                                <NavItem>Lic. en Psicolog&iacute;a Social</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Licenciatura/Sociologia_Educacion'} >
                                                <NavItem>Lic. en Sociolog&iacute;a de la Educaci&oacute;n</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Licenciatura/Sociologia_Politica'} >
                                                <NavItem>Lic. en Sociolog&iacute;a Politica</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Licenciatura/Filologia_y_Literatura'} >
                                                <NavItem>Lic. en Filolog&iacute;a y Literatura</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Licenciatura/Contaduria_Publica'} >
                                                <NavItem>Lic. Contadur&iacute;a P&uacute;blica</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Licenciatura/Administracion_de_Empresas'} >
                                                <NavItem>Lic. Administraci&oacute;n de Empresas</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Licenciatura/Economia'} >
                                                <NavItem >Lic. Econom&iacute;a</NavItem>
                                            </LinkContainer>
                                        </NavDropdown>
                                        <NavDropdown title={this.MenuDip()} >

                                            <LinkContainer to={'/Diplomados/TDAH'} >
                                                <NavItem>Dipl. en Inclusi&oacute;n de niños con TDAH</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Diplomados/Autismo'} >
                                                <NavItem>Dipl. en Inclusi&oacute;n de niños con Autismo</NavItem>
                                            </LinkContainer>
                                            <LinkContainer to={'/Diplomados/Formacion-Profesores-Diseño-de-Cursos-en-Linea'} >
                                                <NavItem>Diplomado Diseño de cursos en línea</NavItem>
                                            </LinkContainer>
                                            {
                                                //<LinkContainer to={'/Diplomados/Aplicaciones_Google'} >
                                                //    <NavItem>Dipl. Uso did&aacute;ctico en el aula de las aplicaciones de Google</NavItem>
                                                //</LinkContainer>

                                            }
                                        </NavDropdown>

                                    </Nav>
                                </Navbar.Collapse>
                            </Navbar>
                        </Col>
                    </Row>
                </Grid>
            </div>
            
        );
    }

}


export default MenuPrincipal;



// WEBPACK FOOTER //
// ./src/components/MenuPrincipal.js